
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Calendar, Users, ArrowRight } from 'lucide-react';

const Index: React.FC = () => {
  const navigate = useNavigate();
  
  // Debug log om te bevestigen dat de component wordt gerenderd
  useEffect(() => {
    console.log('Index pagina wordt gerenderd en gemount');
    
    // Log informatie over de browser-omgeving
    console.log('User Agent:', navigator.userAgent);
    console.log('Window size:', window.innerWidth, 'x', window.innerHeight);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 px-4 py-12">
      <div className="max-w-3xl text-center space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-primary/10 p-6 mb-3">
            <Calendar className="h-16 w-16 text-primary" />
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold">RoosterApp</h1>
        <p className="text-xl text-muted-foreground max-w-xl mx-auto">
          Eenvoudig en efficiënt uw personeel inplannen met onze intuïtieve rooster-applicatie.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4 pt-4">
          <Button 
            onClick={() => {
              console.log('Navigeren naar Dashboard');
              navigate('/dashboard');
            }}
            size="lg"
            className="gap-2"
          >
            Ga naar Dashboard
            <ArrowRight className="h-4 w-4" />
          </Button>
          
          <Button 
            onClick={() => {
              console.log('Navigeren naar Login');
              navigate('/login');
            }}
            variant="outline"
            size="lg"
            className="gap-2"
          >
            <Users className="h-4 w-4" />
            Inloggen
          </Button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="rounded-full bg-blue-100 p-3 w-12 h-12 flex items-center justify-center mb-4">
              <Calendar className="h-6 w-6 text-blue-600" />
            </div>
            <h3 className="text-xl font-medium mb-2">Eenvoudige Planning</h3>
            <p className="text-muted-foreground">
              Maak roosters aan met onze intuïtieve drag-and-drop interface.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="rounded-full bg-green-100 p-3 w-12 h-12 flex items-center justify-center mb-4">
              <Users className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="text-xl font-medium mb-2">Personeelsbeheer</h3>
            <p className="text-muted-foreground">
              Beheer uw medewerkers en hun beschikbaarheid op één plek.
            </p>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="rounded-full bg-purple-100 p-3 w-12 h-12 flex items-center justify-center mb-4">
              <svg className="h-6 w-6 text-purple-600" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 10V20M8 10L4 9.99998V20L8 20M8 10L13.1956 3.93847C13.6886 3.3633 14.4642 3.11604 15.1992 3.29977L15.2467 3.31166C16.5885 3.64711 17.1929 5.21057 16.4258 6.36135L14 9.99998H18.5604C19.8225 9.99998 20.7691 11.1547 20.5216 12.3922L19.3216 18.3922C19.1346 19.3271 18.3138 20 17.3604 20L8 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-xl font-medium mb-2">Moeiteloze Communicatie</h3>
            <p className="text-muted-foreground">
              Houd iedereen op de hoogte met automatische notificaties.
            </p>
          </div>
        </div>
        
        <p className="text-sm text-muted-foreground mt-12">
          © {new Date().getFullYear()} RoosterApp • Alle rechten voorbehouden
        </p>
      </div>
    </div>
  );
};

export default Index;
